import { render, staticRenderFns } from "./UnitGroupManage.vue?vue&type=template&id=916f8e22"
import script from "./UnitGroupManage.vue?vue&type=script&lang=js"
export * from "./UnitGroupManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports